export const SERVICES = {
  ORGS: "/orgs",
  ORG_CHARTS: "/org_charts",
  ORG_NODES: "org_nodes",
  ORGS_SAVE: "/orgs/save",
  ORGS_UPDATE_SORT_INDEX: "/orgs/update_sort_index",
  LOGIN: "/auth/sign_in",
  SIGN_OUT: "/auth/sign_out",
  COMPANIES: "/companies",
  AUTH: "/me",
  WORKERS: "/workers",
  WORKERS_SALARY_LIST: "/workers/salary_list",
  PERSONS: "/persons",
  USERS: "/users",
  BRANCHES: "/branches",
  DIVISIONS: "/divisions",
  DEPARTMENTS: "/departments",
  ORGANIZATIONS: "/organizations",
  PDF: "/export/pdf",
  PDF_JSON: "/export/pdf",
  TRANSFER_SAVE: "/transfers/save",
  PROVISIONS_SAVE: "/provisions/save",
  WORKERS_SAVE: "/workers/save",
  USERS_SAVE: "/users/save",
  TRANSFER: "/transfers",
  PROVISIONS: "/provisions",
  EXPENSES_SAVE: "/expenses/save",
  EXPENSES: "/expenses",
  DEDUCTIONS: "/deductions",
  DEDUCTIONS_SAVE: "/deductions/save",
  WORKS_SAVE: "/works/save",
  WORKS: "/works",
  WORK_COLUMNS_SAVE: "/work_columns/save",
  WORK_COLUMNS: "/work_columns",
  ARRANGEMENTS: "/arrangements",
  ARRANGEMENTS_SAVE: "/arrangements/save",
  WORKER_TAXSHEETS_SAVE: "/worker_taxsheets/save",
  WORKER_TAXSHEETS: "/worker_taxsheets",
  ADMIN_CONFIG: "/admin/config/import",
  ACCOUNT_TITLE_CONFIG: "/admin/config/import_account_titles",
  LATEST_IMPORT: "/admin/config/latest-import",
  ACCOUNT_TITLES: "/account_titles",
  PROVISION_ITEMS: "/provision_items",
  PROVISION_ITEMS_SAVE: "/provision_items/save",
  EXPENSE_ITEMS: "/expense_items",
  PREFECTURES: "/prefectures",
  APPS: "/apps",
  SAVE_RECORDS: "/save_records",
  APPRAISALS: "/appraisals",
  CATEGORY_STATUSES: "/category_statuses",
  CATEGORY_STATUS_COMPANIES: "/category_status_companies",
  CATEGORY_STATUS_WORKER_SETTINGS: "/category_status_worker_settings",
  CATEGORY_STATUS_USER_SETTINGS: "/category_status_user_settings",
  APPRAISAL_SETTINGS: "/appraisal_settings",
  APPRAISAL_SHEETS: "/appraisal_sheets",
  APPRAISAL_SHEET_DETAILS: "/appraisal_sheet_details",
  APP_PART: "/app_parts",
  APPS_CREATE: "/records/create",
  APPS_RECORDS: "/records",
  APP: "/app",
  UPLOAD_ATTACHMENT: "/upload/attachment",
  CLIENTS: "/clients",
  CHAT_CATEGORIES: "/chat_categories",
  CHAT_STATUSES: "/chat_statuses",
  CHAT_THREADS: "/chat_threads",
  PROJECTS: "/projects",
  PROJECTS_SAVE: "/projects/save",
  TASKS: "/tasks",
  TASK_LOG_DETAILS: "/task_log_details",
  TASK_LOGS: "/task_logs",
  TASKS_SAVE: "/tasks/save",
  CONFIGS: "/configs/basic_values",
  PERMISSIONS: "/permissions",
  TABLE_META_CONFIGS: "/configs/table_meta_configs",
  POSITIONS: "/positions",
  APP_CATEGORIES: "/app_categories",
  APP_CATEGORIES_UPDATE_SORT_INDEX: "/app_categories/update_sort_index",
  APP_PERMISSIONS: "/app_permissions",
  ANNUAL_SUMMERIES: "/annual_summeries",
  SALARY_PERMISSIONS: "/annual_summeries/salary_permissions",
  INVITE_TO_COMPANY: "/invite-to-company",
  KPI_ELEMENTS: "/kpi_elements",
  BUSINESS_PLANS: "/business_plans",
  ACCOUNT_CATEGORIES: "/account_categories",
  KPI_CLASSIFICATION: "/kpi_classifications",
  E_LEARNING_COURSE: "/e_learning_courses",
  E_LEARNING_COURSE_ON_STORE: "/e_learning_courses/on_store",
  E_LEARNING_LESSON: "/e_learning_lessons",
  PUBLIC: "/publish",
  UPLOAD_MULTIPLE_MEDIA: "/upload/multiple_files",
  UPLOAD_SINGLE_MEDIA: "/upload/attachment",
  UPLOAD_SINGLE_VIDEO: "/upload/video",
  COMPANY_MENU_SETTINGS: "/company_menu_settings",
  BUY: "/buy",
  HISTORIES: "/histories",
  VIEWERS: "/viewers",
  INDUSTRY_CATEGORIES: "/industry_categories",
  INDUSTRY_CATEGORY_TAX_CONFIGS: "/industry_category_tax_configs",
  CUSTOM_FILTER_CONFIGS: "/custom_filter_configs",
  WORKER_ON_COMPANY: "/workers/workers_on_company",
  LIST_LESS_FIELDS: "/list_less_fields",
  E_LEARNING_PERMISSIONS: "/e_learning_permissions",
  LIST_COMPANIES: "/list_companies",
  CLONE_RECORDS: "/records/clone_records",
  MAINTENANCE_NOTICES: "/maintenance_notices",
  COMPARE_TAX_DEFINITION: "/admin/config/compare_tax_definition",
  COMPANY_INOICES: "/company_invoices",
  COMPANY_INOICES_SAVE: "/company_invoices/save",
  COMPANY_INOICES_DELETE: "/company_invoices/delete",
  COMPANY_BANK_INFOS: "/company_bank_infos",
  COMPANY_LEADERSHIPS: "/company_leaderships",
  COMPANY_NAMES: "/company_names",
  COMPANY_LOCATIONS: "/company_locations",
  COMPANY_ACCOUNTING_PERIODS: "/company_accounting_periods",
  COMPANY_TAX_HISTORIES: "/company_tax_histories",
  COMPANY_FINANCIAL_STATEMENTS: "/company_financial_statements",
  COMPANY_REGULATIONS: "/company_regulations",
  COMPANY_REGULATIONS_SAVE: "/company_regulations/save",
  COMPANY_FINANCIAL_SAVE: "/company_financial_statements/save",
  COMPANY_REGISTRATION_INFOS: "/company_registration_infos",
  COMPANY_PHONE_NUMBERS: "/company_phone_numbers",
  WORKERS_RELATIONS: "/workers/relations",
  WORKER_BACKGROUNDS: "/worker_backgrounds",
  WORKER_DEATH_INFO: "/worker_death_info",
  WORKER_BASIC_INFORMATION: "/worker_basic_information",
  PREVIOUS_EMPLOYMENT_COMPANIES: "/previous_employment_companies",
  WORKER_ORG_CHART_NODE_HISTORIES: "/worker_org_chart_node_histories",
  WORKER_DOCUMENTS: "/worker_documents",
  WORKER_REGISTRATION_CODES: "/worker_registration_numbers",
  WORKER_DEPENDANTS: "/worker_dependants",
  WORKER_DEPENDANT_NAMES: "/worker_dependant_names",
  WORKER_DEPENDANT_RELATIONSHIPS: "/worker_dependant_relationships",
  USER_TABLE_COLUMN_SETTINGS: "/user_table_column_settings",
  COMPANY_PERMISSIONS: "/company_permissions",
  WORKER_PERMISSIONS: "/worker_permissions",
  COMPANY_WORKER_PERMISSIONS: "/company_permission_workers",
  LIST: "/list",
  USER_INTERFACE_SETTINGS: "/user_interface_settings",
  WORKER_LOGTIMES: "/worker_logtimes",
  APPLICATIONS: "/applications",
  SUBSCRIPTION: "/subscriptions",
  PAYMENT_HISTORY: "/payment_histories",
  CREATE_SUBSCRIPTION: "/paypal/create-subscription",
  COMPANY_APP_ESTIMATES: "/company_app_estimates",
  COMPANY_V2: "/companies/contract_status",
  CLIENT_NAMES: "/client_names",
  CLIENT_PHONE_NUMBERS: "/client_phone_numbers",
  CLIENT_INVOICES: "/client_invoices",
  CLIENT_BANK_INFOS: "/client_bank_infos",
  CLIENT_LEADERSHIPS: "/client_leaderships",
  CLIENT_ACCOUNTING_PERIODS: "/client_accounting_periods",
  CLIENT_REGISTRATION_INFOS: "/client_registration_infos",
  CLIENT_TAX_HISTORIES: "/client_tax_histories",
  CLIENT_LOCATIONS: "/client_locations",
  CLIENT_CONTRACT_STATUSES: "/client_contract_statuses",
  CLIENT_CONTRACT_TYPES: "/client_contract_types",
  BIZ_PROJECT_MANAGER: "/biz_projects",
  BIZ_MEETINGS: "/biz_meetings",
  /** GET list (query: biz_project_id). Response shape matches GET /biz_meetings. */
  BIZ_MEETINGS_LIST: "/biz_meetings/list_biz_meetings",
  BIZ_PROJECT_LIST_USER_ASSIGNEES: "/biz_projects/list_user_assignees",
  BIZ_PROJECT_MANAGER_PHASE: "/project_phases",
  BIZ_PROJECT_MANAGER_TASK: "/project_tasks",
  /** 見積対象者 — GET list: query `id` = project id */
  QUOTATION_PROVIDERS: "/quotation_providers",
  SETTING_MEMBERS: "/setting_members",
  SETTING_MEMBERS_VALIDATE_WORKER_EMAIL:
    "/setting_members/validate-worker-email",
  SETTING_MEMBERS_OWNER_AND_ADMIN_WORKERS:
    "/setting_members/owner_and_admin_workers",
  CLIENT_SHEETS: "/client_sheet",
  CURRENT_USER_PERMISSIONS: "/current-user-permissions",
  CHECK_INVITE_NOTIFICATION:
    "/worker_share_settings/check_invitation_and_rejection",
  WORKER_SHARE_SETTINGS: "/worker_share_settings",
  WORKER_SETTING_INVITATIONS: "/worker_share_settings/invitations",
  SETTING_MEMBERS_ALL: "/setting_members/all",
  // CLIENT_SHEETS: "/clients/save_client",
  THREADS: "/threads",
  CHAT_ATTACHMENTS: "/chat_attachments",
  COMPANY_INVESTOR_HISTORIES: "company_investor_histories",
  REPORT_FORMS: "/report_forms",
  REPORT_TASKS: "/report_tasks",
  COMPANY_SALARY_MONTHLY: "/company_salary_monthly",
  COMPANY_SALARY_MONTHLY_TOTALS: "/company_salary_monthly/totals",
  COMPANY_POLICY_PERMISSIONS: "/company_policy_permissions",
  ROLE_PERMISSIONS: "/role_permissions",
  SALARY_LEDGERS: "/salary_ledgers",
  SALARY_EXPORTS: "/salary_exports",
  SALARY_LEDGERS_EXPORT: "/salary_exports",
  SALARY_LEDGERS_EXPORT_HISTORIES: "/salary_exports",
  INTERNAL_CONTROL_RECORD_PERMISSIONS: "/internal_control_record_permissions",
};
